export default function Logo({ dark = false, size = 36 }) {
    return (
        <span className="inline-flex items-center gap-2.5 select-none">
            <svg width={size} height={size} viewBox="0 0 40 40" fill="none" aria-hidden="true">
                <rect width="40" height="40" rx="12" fill="#18542A" />
                <path d="M12 28L18 12L24 28" stroke="#FFFDF7" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M26 18L30 18C31.1 18 32 18.9 32 20C32 21.1 31.1 22 30 22L26 22" stroke="#FFD166" strokeWidth="3.5" strokeLinecap="round" />
                <circle cx="15" cy="22" r="2.5" fill="#FF6B6B" />
            </svg>
            <span className={`font-display text-2xl font-extrabold tracking-tight leading-none ${dark ? "text-brand-cream" : "text-brand-ink"}`}>
                Acture<span className={dark ? "text-brand-sunshine" : "text-brand-forest"}>.id</span>
            </span>
        </span>
    );
}
